import LocationDayScheduleOptions from './LocationDayScheduleOptions.view';

export default LocationDayScheduleOptions;
